import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { SpecialRequirementSelectionModel } from '../../models/special-requirment-selection.model';
@Component({
  selector: 'jsg-hearing-details-view',
  templateUrl: './hearing-details-view.component.html',
  styleUrls: ['./hearing-details-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HearingDetailsViewComponent implements OnInit {
  @Input() remedySought: string;
  @Input() contestedType: string;
  @Input() hearingMethod: string;
  @Input() specialRequirementNotes: string;
  @Input() specialRequirementsSelection: SpecialRequirementSelectionModel[];
  @Input() urgencyDates: string;

  constructor() {}

  ngOnInit(): void {}

  public getEndTime(startTime: Date, duration: number) {
    startTime = new Date(startTime);
    let endDate = startTime;
    return endDate.setMinutes(startTime.getMinutes() + duration);
  }
}
